import { latest as LatestVDETypes } from '@libs/waymark-video/video-descriptor-types';
import { ImageAsset } from './ImageAsset';
import { FootageAsset } from './FootageAsset';
import { FontAsset } from './FontAsset';
import { AudioAsset } from './AudioAsset';

export const makeAsset = (rawAssetData: LatestVDETypes.Source) => {
  if (rawAssetData && 'type' in rawAssetData) {
    switch (rawAssetData.type) {
      case 'image':
        return new ImageAsset(rawAssetData);
      case 'video':
        return new FootageAsset(rawAssetData);
      case 'bitmapFont':
        return new FontAsset(rawAssetData);
      case 'audio':
        return new AudioAsset(rawAssetData);
    }
  }

  // This is an unsupported asset type
  return null;
};
